<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>아이디 찾기</span><br/>
					회원 계정 유형을 먼저 선택해 주세요.
				</div>
			</div>
		</div>
		<div class="mem_container">
			<div class="main-box">				
				<div class="mem_contents_body">
					<div class="info-box">
						<div class="phone-img account top">
							<p>회원 계정 선택</p>
							<div class="select-box">
								<span v-for="(row, rowIdx) in mberDivList" :key="rowIdx">
									<input type="radio" class="account" name="account" :id="'rdo'+row.mberDivCd" :value="row.mberDivCd" v-model="mberDivCd">
									<label :for="'rdo'+row.mberDivCd">
										<span class="rd"></span>
										{{row.title}}
									</label>
									<span class="account" v-if="mberDivList.length > (rowIdx + 1)">&nbsp;</span>
								</span>
							</div>
							<div class="phone-info account">
								선택하신 계정으로 아이디찾기를 진행하시겠습니까?
							</div>
						</div>
						<div class="phone-btn account">
							<div class="btn-crt account" @click="pageMove()">다음</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { findAccountTypeMeta } from '@/utils/meta';
export default {
	metaInfo : findAccountTypeMeta,
	data() {
		return {
			mberDivList : [
				{
					mberDivCd : '11',
					title     : 'IT 프로',
				},
				{
					mberDivCd : '22',
					title     : '클라이언트',
				},
				{
					mberDivCd : '31',
					title     : '파트너사',
				},
			],

			mberDivCd : '11'
		}
	}, 

	methods : {
		pageMove() {
			var scrNm = 'MEM002M01';
			// if(this.mberDivCd == '20') scrNm = 'MEM002M07';

			this.$router.push({name:scrNm, params:{mberDivCd:this.mberDivCd}});
		}
	}
}
</script>